import messages  from '../../../app-js/messages.js'
export default {
	data () {
		return {
			otp:null,
			password_error:false,
			password:"",
			confirm_password:"",
			rules:{
				passwordRule: [v => !!v || messages.PASSWORD_ERROR],
				confirmPasswordRule: [v => !!v || messages.CONFIRM_PASSWORD_ERROR],
			},
		}
	},
	methods:{
		matchPassword(){
			if(this.password!=this.confirm_password)
				this.password_error=true;
			else
				this.password_error=false

		},
		resetpassword(){

			const self=this;
			if (this.$refs.wholesaler_signup_form.validate()==false)
				return false

			var	 form = new URLSearchParams();
			form.append("password",self.password);

			const successHandler = (response) => {
				console.log(response)
				if(response.data.success){
					this.$store.dispatch('auth/setAuthStep', 1)
					// this.$store.dispatch('drawer/setActiveTab',1)
					sessionStorage.clear() ; 
					self.$router.push({name:"login"})
				}
			};
			this.request_POST(self,this.$urls.RESET_PASSWORD,form,successHandler)

		}
		
	}
}